export class AppConstants {

  public static fileFolderPath = 'https://otojet.com/assets/images/uploaded_images/';
  public static API_ENDPOINT = 'https://admin.otojet.com/otojet-ws';
  public static API_ENDPOINT_SPRING = 'https://adminotojet.herokuapp.com/';
  //public static API_ENDPOINT_SPRING='http://localhost:2708/';
  /*local
   public static fileFolderPath = 'http://otojet.com/assets/images/uploaded_images/';
   public static API_ENDPOINT='http://localhost:2709';
   public static API_ENDPOINT_SPRING='http://localhost:2709/';
   */
}



// WEBPACK FOOTER //
// C:/Users/user/Desktop/otojet-git/OtojetUI-Spring-Admin-Project/src/app/app.constants.ts